module.exports = __webpack_public_path__ + "static/media/RIC.30a7e087.png";